import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var TreeViewService = /** @class */ (function () {
    function TreeViewService() {
        this.checkAll$ = new Subject();
        this.checked$ = new Subject();
    }
    TreeViewService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TreeViewService_Factory() { return new TreeViewService(); }, token: TreeViewService, providedIn: "root" });
    return TreeViewService;
}());
export { TreeViewService };
